import { render, staticRenderFns } from "./LabelGroup.vue?vue&type=template&id=2ac687d6"
var script = {}
import style0 from "./LabelGroup.vue?vue&type=style&index=0&id=2ac687d6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports